import React from "react";
import { RaisedButton, DropDownMenu, MenuItem } from "material-ui";
import InlineLinkIconButton from "./inline-link-icon-button.jsx";

import PassActions from "../../actions/PassActions";

class PassSubtitleEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      isSaving: false,
      _lastUpdatedAt: null,
      updatedBucket: null
    };

    this._save = this._save.bind(this);
    this._onChange = this._onChange.bind(this);
    this._startEditing = this._startEditing.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentWillReceiveProps(newProps) {
    if (newProps.pass.updated_at !== this.state._lastUpdatedAt) {
      this.setState({
        isSaving: false,
        isEditing: false
      });
    }
  }

  _save() {
    if (!this.state.updatedBucket) {
      this.setState({
        isEditing: false,
        updatedBucket: null
      });
      return;
    }

    this.setState(
      {
        isSaving: true,
        _lastUpdatedAt: this.props.pass.updated_at
      },
      () => {
        PassActions.edit(this.props.pass.id, {
          pass_bucket: this.state.updatedBucket
        });
      }
    );
  }

  _startEditing(e) {
    e.preventDefault();
    this.setState({
      isEditing: true
    });
  }

  _onChange(e, index, value) {
    this.setState({
      updatedBucket: value
    });
  }

  getStyles() {
    return {
      editor: {
        marginTop: -13,
        marginBottom: 4
      },
      editButton: {
        height: 28
      },
      editButtonLabel: {
        lineHeight: "28px"
      },
      textField: {
        lineHeight: "16px",
        height: 40,
        width: "60%",
        maxWidth: 250
      }
    };
  }

  render() {
    let { pass, passBuckets } = this.props,
      styles = this.getStyles();

    let menuItems = passBuckets.map((b, i) => {
      return (
        <MenuItem
          key={i}
          primaryText={b.name}
          value={b.id}
          style={{ cursor: "pointer" }}
        />
      );
    });

    return this.state.isEditing ? (
      <div style={styles.editor}>
        <DropDownMenu
          style={{ marginLeft: -24 }}
          value={this.state.updatedBucket || pass.pass_bucket.id}
          onChange={this._onChange}
        >
          {menuItems}
        </DropDownMenu>
        <div style={{ marginTop: 5 }}>
          <RaisedButton
            label={this.state.isSaving ? "Saving..." : "Save"}
            primary={true}
            disabled={this.state.isSaving}
            style={styles.editButton}
            labelStyle={styles.editButtonLabel}
            onTouchTap={this._save}
          />
        </div>
      </div>
    ) : (
      <div style={{ whiteSpace: "nowrap" }}>
        {pass.pass_bucket.name}
        {this.props.showEditButton ? (
          <span> </span>
        ) : (
          <InlineLinkIconButton
            onTouchTap={() => {
              this.context.router.push(
                `/event_buckets/${pass.event_bucket.id || pass.event_bucket
                }/${pass.pass_bucket.is_membership ? "memberships" : "pass_buckets"}/${pass.pass_bucket.id}`
              );
            }}
            tooltip={`View ${pass.pass_bucket.is_membership ? "membership" : "pass bucket"}`}
          />
        )}
        {this.props.showEditButton && (
          <span>
            (
            <a href="#" onClick={this._startEditing}>
              edit
            </a>
            )
          </span>
        )}
      </div>
    );
  }
}

export default PassSubtitleEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-pass-bucket-editor.jsx